export default [
  {
    path: "/fops/payment-options",
    name: "Fops-list",
    component: () => import("@/views/fops/paymentoptions/paymentoptions.vue"),
    meta: {
      resource: "MerchantFOP",
      action: "View",
    },
  },
  {
    path: "/fops/all-payment-options",
    name: "AllFops-list",
    component: () =>
      import("@/views/fops/paymentoptions/allpaymentoptions.vue"),
    meta: {
      resource: "AllFOP",
      action: "View",
    },
  },

  {
    path: "/fops/instructions/:id/:name",
    name: "instructions-manage",
    component: () => import("@/views/fops/instructions/instructions.vue"),
    meta: {
      resource: "MerchantFOP",
      action: "ManageInstructions",
    },
  },
  {
    path: "/fops/country-currency",
    name: "CountryCurrency-list",
    component: () => import("@/views/fops/paymentoptions/countryCurrency.vue"),
    meta: {
      resource: "CountryCurrency",
      action: "View",
    },
  },

];
